<script>
  import { onMount } from 'svelte';
</script>

<div class="legal-container">
  <h1>Privacy Policy</h1>
  <p class="last-updated">Last Updated: December 18, 2025</p>

  <section>
    <h2>1. Information We Collect</h2>
    <p>We collect information you provide directly to us, such as when you create or modify your account, request on-demand services, contact customer support, or otherwise communicate with us. This information may include: name, email, phone number, postal address, profile picture, payment method, items requested (for delivery services), delivery notes, and other information you choose to provide.</p>
  </section>

  <section>
    <h2>2. How We Use Your Information</h2>
    <p>We use the information we collect to provide, maintain, and improve our Services, such as to process payments, send receipts, provide products and services you request (and send related information), develop new features, provide customer support to Users and Drivers, develop safety features, authenticate users, and send product updates and administrative messages.</p>
  </section>

  <section>
    <h2>3. Sharing of Information</h2>
    <p>We may share the information we collect about you as described in this Statement or as described at the time of collection or sharing, including with third party vendors, consultants and other service providers who need access to such information to carry out work on our behalf.</p>
  </section>

  <section>
    <h2>4. Security</h2>
    <p>We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.</p>
  </section>

  <div class="footer-note">
  </div>
</div>

<style>
  .legal-container {
    max-width: 800px;
    margin: 2rem auto;
    padding: 2rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    line-height: 1.6;
    color: #333;
    text-align: left;
  }

  h1 {
    color: #007bff;
    margin-bottom: 0.5rem;
  }

  .last-updated {
    color: #666;
    font-style: italic;
    margin-bottom: 2rem;
    border-bottom: 1px solid #eee;
    padding-bottom: 1rem;
  }

  h2 {
    font-size: 1.5rem;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #444;
  }

  section {
    margin-bottom: 1.5rem;
  }

  .footer-note {
    margin-top: 3rem;
    padding-top: 1rem;
    border-top: 1px solid #eee;
    text-align: center;
    color: #888;
    font-size: 0.9rem;
  }
</style>